<template>
  <v-container
    fluid
    class="background-color-white border-bottom position-fixed z-index-2"
  >
    <v-row class="pt-1 px-4">
      <v-col
        style="flex: 0 0 20%; max-width: 20%"
        class="d-flex justify-space-between px-0"
      >
        <XsLoginButton />
        <XsRewardsButton
          v-if="authorized && includeLoyalty && (hasClubs || hasPoints)"
        />
      </v-col>
      <v-col
        style="flex: 0 0 60%; max-width: 60%"
        class="align-center d-flex justify-center px-0 py-0"
      >
        <h1
          class="color-black-magic font-size-sm font-weight-semibold text-uppercase"
        >
          {{ wait(storeInfo, "name") }}
        </h1>
      </v-col>
      <v-col
        style="flex: 0 0 20%; max-width: 20%"
        class="d-flex px-0"
        :class="rewardsFormat ? 'justify-end' : 'justify-space-between'"
      >
        <v-btn fab x-small :to="{ name: 'about' }" v-if="!rewardsFormat">
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>
        <div class="position-relative" v-if="!rewardsFormat">
          <Badge />
          <XsCartButton />
        </div>
        <div class="position-relative" v-else>
          <XsHomeButton />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <InactiveXsSearch v-if="!rewardsFormat" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { wait } from "@/util.js";
import Badge from "@/components/UI/Badge.vue";
import InactiveXsSearch from "@/components/Search/Xs/Inactive.vue";
import XsCartButton from "@/components/Auth/Buttons/Xs/Cart.vue";
import XsHomeButton from "@/components/Auth/Buttons/Xs/Home.vue";
import XsLoginButton from "@/components/Auth/Buttons/Xs/Login.vue";
import XsRewardsButton from "@/components/Auth/Buttons/Xs/Rewards.vue";

export default {
  name: "XsStandardHeader",
  components: {
    Badge,
    InactiveXsSearch,
    XsCartButton,
    XsHomeButton,
    XsLoginButton,
    XsRewardsButton,
  },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
    ...mapGetters("auth", { authorized: "isAuthenticated" }),
    ...mapGetters("store", {
      hasPoints: "hasPoints",
      hasClubs: "hasClubs",
      rewardsFormat: "rewardsFormat",
    }),
  },
  data() {
    return {
      includeLoyalty:
        process.env.VUE_APP_INCLUDE_LOYALTY.toLowerCase() === "true",
    };
  },
  methods: {
    wait,
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 2px solid #dadada;
}

.position-fixed {
  position: fixed;
  top: 4px;
}

.z-index-2 {
  z-index: 2;
}
</style>
